"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({edit}) {
        this.state = {
            editing: !!edit,
            submitting: false,
            showPosterPlus: false
        };
        this.fhandler = new FormHandler();
        this.fhandler.bind(this, edit || {});
    },
    onDestroy: function () {
        this.fhandler.reset();
    },
    onSelectPoster: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onSetPoster: function ({base64, src}) {
        if (!src)
            return;
        this.fhandler.set('poster', base64 || src);
        this.state.showPosterPlus = false;
    },
    onSave: function () {
        this.state.submitting = true;
        this.emit('submit', this.state.editing ? 'edit' : 'add', this.state.form, function () {
            this.state.submitting = false;
            this.emit('dismiss');
        }.bind(this));
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Categories/components/AddEdit.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    PosterInput_template = require("../../../components/PosterInput.marko"),
    PosterInput_tag = marko_loadTag(PosterInput_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    PosterPlus_template = require("../../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 vh-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("e9d796"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node3 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "text-muted"
      },
    marko_attrs5 = {
        "class": "col-5"
      },
    marko_attrs6 = {
        "class": "col"
      },
    marko_attrs7 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs8 = {
        "class": "col text-right"
      },
    marko_attrs9 = {
        "class": "btn btn-primary btn-lg mx-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.e("div", marko_attrs1, "1", component, 0, 0, {
      onclick: __component.d("click", () => component.emit('dismiss'), false)
    });

  Row_tag({
      class: "m-0 position-relative w-100 h-100 d-flex justify-content-center",
      renderBody: function(out) {
        WSAdapt_tag({
            hs: "col-8",
            qs: "col-5",
            ns: "col-4",
            class: "animated zoomIn faster",
            renderBody: function(out) {
              out.be("h5", null, "4", component);

              Locale_tag({
                  text: (state.editing ? "Edit" : "Create") + " Category"
                }, out, __component, "5");

              out.ee();

              if (!state.editing) {
                out.be("p", marko_attrs4, "6", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("For departments, courses, programs, ...");
                    }
                  }, out, __component, "7");

                out.ee();
              }

              out.n(marko_node0, component);

              Row_tag({
                  class: "form-group",
                  renderBody: function(out) {
                    out.be("div", marko_attrs5, "10", component);

                    PosterInput_tag({
                        src: state.form.poster,
                        style: "height:12rem",
                        icon: "bx bx-category",
                        btn: Locale((state.editing ? "Edit" : "Add") + " Image")
                      }, out, __component, "11", [
                      [
                        "click",
                        "onSelectPoster",
                        false,
                        [
                            true
                          ]
                      ]
                    ]);

                    out.ee();
                  }
                }, out, __component, "9");

              out.n(marko_node1, component);

              out.be("div", marko_attrs2, "13", component);

              out.be("label", null, "14", component);

              Locale_tag({
                  text: "Title",
                  class: "text-muted"
                }, out, __component, "15");

              out.ee();

              out.n(marko_node2, component);

              out.e("input", {
                  type: "text",
                  value: state.form.name,
                  name: "name",
                  "class": marko_classValue("form-control form-control-xl px-2" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Name*")
                }, "17", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2" + (!state.formError.name ? " d-none" : ""))
                }, "18", component, null, 1);

              Locale_tag({
                  text: "This field is required"
                }, out, __component, "19");

              out.ee();

              out.ee();

              out.be("div", marko_attrs3, "20", component);

              out.be("label", null, "21", component);

              Locale_tag({
                  text: "Description",
                  class: "text-muted"
                }, out, __component, "22");

              out.ee();

              out.n(marko_node3, component);

              out.e("textarea", {
                  value: state.form.description,
                  name: "description",
                  "class": marko_classValue("form-control form-control-xl px-2 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                  placeholder: Locale("Description"),
                  style: marko_styleValue({
                      height: "100px",
                      resize: "none"
                    })
                }, "24", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.ee();

              out.n(marko_node4, component);

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs6, "27", component);

                    out.be("button", marko_attrs7, "28", component, null, 0, {
                        onclick: __component.d("click", () => component.emit('dismiss'), false)
                      });

                    Locale_tag({
                        text: "Cancel"
                      }, out, __component, "29");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs8, "30", component);

                    out.be("button", marko_attrs9, "31", component, null, 0, {
                        onclick: __component.d("click", "onSave", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.submitting
                      }, out, __component, "32");

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "33");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "26");
            }
          }, out, __component, "3");
      }
    }, out, __component, "2");

  out.ee();

  if (state.showPosterPlus == true) {
    PosterPlus_tag({
        cdn: "course",
        width: 280,
        height: 280,
        maxSize: 1024,
        accepts: "image/*",
        theme: input.themeMode
      }, out, __component, "34", [
      [
        "done",
        "onSetPoster",
        false
      ],
      [
        "cancelled",
        "onSelectPoster",
        false,
        [
            false
          ]
      ]
    ]);
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
